export default __webpack_public_path__ + "static/1173-5cbb301324761ff9945243a2d394494f.gif";